import { useTranslation } from "react-i18next";
import { VOUCHER_CUSTOMER_IS_AMAZON_BUSINESS, VOUCHER_CUSTOMER_IS_NOT_AMAZON_BUSINESS } from "../../../component/Constants";

export const useVoucherIsAmazonBusiness = () => {
  const { t } = useTranslation(["salesmarketing"],{keyPrefix:'voucher'});

  const isAmazonBusinessFilterValues = [
    {
      value: VOUCHER_CUSTOMER_IS_AMAZON_BUSINESS,
      label: t("isAmazonBusiness.yes"),
    },
    {
      value: VOUCHER_CUSTOMER_IS_NOT_AMAZON_BUSINESS,
      label: t("isAmazonBusiness.no"),
    },
  ];

  return {
    isAmazonBusinessFilterValues,
  };
};
